import React, { useState, createContext, useContext } from "react";

// context for managing registration data in Register screen
const initalState = {
    language: 'ID',
};

const LanguageContext = createContext(initalState);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ID'); // Stores questions and answers
  return (
    <LanguageContext.Provider
      value={{
        language, setLanguage
      }}
    >
      {/* {renderComponent()} */}
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);
